<div id="tabContainer" class="tab-section" (window:resize)="onResize($event)" 
    (keydown)="handleKeyDown($event)" (click)="handleTabsClick($event)" role="tablist"
    attr.aria-label="{{ariaLabel}}">
  <div class="tab-nav" >
    <ng-content></ng-content>
    <div class="clearfix"></div>
  </div>
</div>
